import React from 'react';
import { Message } from 'rsuite';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Message
          showIcon
          closable
          type="error"
          title="Something went wrong"
          description={this.state.error?.message || 'An unexpected error occurred'}
          style={{ marginBottom: 16 }}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
